module.exports = __webpack_public_path__ + "img/poslovne_jedinice.5ca09f4e.png";